import script from "./FireworkModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FireworkModal.vue?vue&type=script&setup=true&lang=js"

import "./FireworkModal.vue?vue&type=style&index=0&id=6083fd52&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6083fd52"]])

export default __exports__